import _ from 'lodash';
import ah from '../utils/ajax-helper'; // time format: YYYY-MM-dd HH:MM:ss
// 取得貨運業者列表

export var getLogistics = function getLogistics(contextRoot, noProgress, sort) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var onlyUser = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit,
      onlyUser: onlyUser
    };
    ah.get("".concat(contextRoot, "/logistic/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得駕駛列表

export var getDriverList = function getDriverList(contextRoot, noProgress, sort) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var keyword = arguments.length > 5 ? arguments[5] : undefined;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'modifiedAt';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var parameters = {
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit,
      keyword: keyword
    };
    ah.get("".concat(contextRoot, "/driver/list"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得車輛列表

export var getVehicleList = function getVehicleList(contextRoot, noProgress, sort) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var keyword = arguments.length > 5 ? arguments[5] : undefined;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'modifiedAt';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var parameters = {
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit,
      keyword: keyword
    };
    ah.get("".concat(contextRoot, "/vehicle/list"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};